module.exports = __webpack_public_path__ + "../static/img/pt.07d3adb2.png";